export default __webpack_public_path__ + "static/media/homei1.a0f1a214.png";